import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03627b7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "flag" }
const _hoisted_3 = { class: "text" }

import BlockView from "@/components/block/BlockView.vue";
import {FlagOutlined} from "@ant-design/icons-vue";
import BlockTitleView from "@/components/block/BlockTitleView.vue";
import {onMounted, onUnmounted, reactive} from "vue";
import {Json, mockArr, req} from "@/lib/util";
import emit from "@/lib/emit";

interface IActivityAnalysis {
  activity_id: string
  title: string
  counter: Json | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockActivityInProgress',
  setup(__props) {


const info = reactive({list: [] as IActivityAnalysis[], current: 0, loading: false})

onMounted(() => {
  mockArr('activities/in/progress', 'get', 0, 2, {
    'activity_id': '@id',
    title: '@ctitle(6,20)',
    'pay_money|0-888.2': 1,
    'post_count|0-88': 1,
    'view_count|0-888': 1,
    'view_user_count|0-888': 1,
    'share_count|0-888': 1,
    'share_user_count|0-888': 1,
    'pay_count|0-888': 1,
    'pay_user_count|0-888': 1,
  })
  info.loading = true
  emit.on('templates.list.loaded', () => {
    req({
      url: 'activities/in/progress', success: rs => {
        info.list = rs
      }, complete: () => {
        info.loading = false
        emit.emit('templates.progress.loaded')
      }
    })
  })
})

onUnmounted(() => {
  emit.off('templates.list.loaded')
})

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_statistic = _resolveComponent("a-statistic")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_carousel = _resolveComponent("a-carousel")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createBlock(BlockView, {
    spinning: info.loading
  }, {
    default: _withCtx(() => [
      _createVNode(BlockTitleView, null, {
        default: _withCtx(() => [
          _createTextVNode("进行中的活动")
        ]),
        _: 1
      }),
      _createVNode(_component_a_carousel, { "dots-class": "activity-dot" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.list, (a) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "activity-box",
              key: a.activity_id,
              onClick: ($event: any) => (_ctx.$router.push({path:'/activities/activity',query:{activity_id:a.activity_id}}))
            }, [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    class: "title"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_2, [
                        _createVNode(_unref(FlagOutlined)),
                        _createTextVNode("活动")
                      ]),
                      _createElementVNode("span", _hoisted_3, _toDisplayString(a.title), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_a_row, { class: "spacing" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 12,
                    class: "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_statistic, {
                        title: "付款总额",
                        value: a.counter?.['付款总额']
                      }, null, 8, ["value"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_col, {
                    span: 12,
                    class: "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_statistic, {
                        title: "报名人数",
                        value: a.counter?.['报名人数']
                      }, null, 8, ["value"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_a_row, { class: "spacing" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_descriptions, {
                        column: {md:1,lg:1,xl:1,xxl:1},
                        bordered: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_descriptions_item, { label: "浏览次数" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(a.counter?.['浏览次数']), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_a_descriptions_item, { label: "浏览人数" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(a.counter?.['浏览人数']), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_a_descriptions_item, { label: "分享次数" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(a.counter?.['分享次数']), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_a_descriptions_item, { label: "分享人数" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(a.counter?.['分享人数']), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_a_descriptions_item, { label: "成交次数" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(a.counter?.['付款次数']), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_a_descriptions_item, { label: "成交人数" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(a.counter?.['付款人数']), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ], 8, _hoisted_1))
          }), 128))
        ]),
        _: 1
      }),
      (info.list.length == 0)
        ? (_openBlock(), _createBlock(_component_a_empty, {
            key: 0,
            description: "暂无进行中的活动"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["spinning"]))
}
}

})